import React from "react";

const SurveyCheckbox = ({ id, label, checked, disabled, onChange }) => (
  <div className="checkbox survey-engine-checkbox">
    <input
      id={id}
      type="checkbox"
      checked={Boolean(checked)}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <label htmlFor={id}>{label}</label>
  </div>
);

export default SurveyCheckbox;
